import "./sass/main.scss";

import About from "./pages/About/About";
import NavBar from "./components/Nav_Bar/Nav_Bar";
import ContactMe from "./pages/Contact_Me/Contact_Me";
import LandingPage from "./pages/Landing_Page/Landing_Page";
import Work from "./pages/Work/Work";
import LanguageState from "./context/LanguageState";
import ToggleSwitch from "./components/ToggleSwitch/ToggleSwitch";

const App = () => {
  return (
    <LanguageState>
      <div className="App">
        <ToggleSwitch />
        <NavBar />
        <LandingPage />
        <About />
        <Work />
        <ContactMe />
      </div>
    </LanguageState>
  );
};

export default App;
